(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebd-hp-50-50-slider"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.ebd-hp-50-50-slider .swiper', {
    loop: true,
    slidesPerView: 1,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.ebd-hp-50-50-slider .swiper-button-next',
      prevEl: '.ebd-hp-50-50-slider .swiper-button-prev',
    },
    breakpoints: {
      1000: {
        autoHeight: false,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-pdp-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperEl = document.querySelector('.ebd-pdp-comparison .swiper');    
    new Swiper('.ebd-pdp-comparison .swiper', {
      slidesPerView: 1,
      autoHeight: true,
      loop: true,
      effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebd-pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.ebd-pdp-ingredients .ingredient');
    const ingredientWrappers = document.querySelectorAll('.ebd-pdp-ingredients .ingredient-wrapper');

    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const ingredientId = this.getAttribute('data-ingredient-id');

        buttons.forEach(btn => btn.classList.remove('active'));
        ingredientWrappers.forEach(wrapper => wrapper.classList.remove('active'));

        this.classList.add('active');
        document.querySelector(`.ingredient-wrapper[data-ingredient-id="${ingredientId}"]`).classList.add('active');
      });
    });
  });

  const mobileSelect = document.querySelector('.ebd-pdp-ingredients .ingredient-mobile-select');
    
    if (mobileSelect) {
    mobileSelect.addEventListener('change', function() {
      const selectedId = this.value;
      const ingredientWrappers = document.querySelectorAll('.ebd-pdp-ingredients .ingredient-wrapper');
      
      ingredientWrappers.forEach(wrapper => wrapper.classList.remove('active'));
      document.querySelector(`.ingredient-wrapper[data-ingredient-id="${selectedId}"]`).classList.add('active');
    });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-store-presence"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", () => {
    gsap.registerPlugin(ScrollTrigger);

    const globe = document.querySelector(".block-globe");
    const trailNotes = document.querySelector(".trail-notes-section");
    if (!globe || !trailNotes) return;

    gsap.to(globe, {
      top: -80,
      scale: 1.05,
      scrollTrigger: {
        trigger: ".in-store-presence-section",
        start: "top bottom",
        end: "bottom 65%",
        scrub: true,
        invalidateOnRefresh: true,
        onUpdate: () => {
          const trailNotesTop = trailNotes.getBoundingClientRect().top;
          const globeBottom = globe.getBoundingClientRect().bottom;
          if (globeBottom < trailNotesTop) {
            const currentTop = parseFloat(gsap.getProperty(globe, "top")) || 0;
            gsap.set(globe, { top: currentTop + (trailNotesTop - globeBottom) + 1 });
          }
        }
      }
    });

    ScrollTrigger.refresh();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-the-news"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const slider = document.getElementById("newsSlider");
    if (!slider) return;

    const card = slider.querySelector(".in-the-news-card");
    if (!card) return;

    const cardWidth = card.offsetWidth;
    const gap = 40; // Match the gap in CSS
    const scrollDistance = cardWidth + gap;

    const leftArrow = document.querySelector(".news-arrow-left");
    const rightArrow = document.querySelector(".news-arrow-right");

    leftArrow?.addEventListener("click", () => {
      slider.scrollLeft -= scrollDistance;
    });

    rightArrow?.addEventListener("click", () => {
      slider.scrollLeft += scrollDistance;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-ingredients-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", () => {
    // No spinning images when the section shows a photo
    if (!document.getElementById("spin-image-left")) return;
    gsap.registerPlugin(ScrollTrigger);

    gsap.to("#spin-image-left", {
      rotate: -20,
      scale: 1.1,
      scrollTrigger: {
        trigger: "#spin-image-left",
        start: "top bottom",
        end: "bottom top-=10%",
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    gsap.to("#spin-image-right", {
      rotate: 20,
      scale: 1.1,
      scrollTrigger: {
        trigger: ".real-banner",
        start: "top bottom",
        end: "bottom top-=10%",
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    // Refresh ScrollTrigger after animations are initialized
    ScrollTrigger.refresh();
  });

  } catch(e) { console.error(e); }
})();
})();
